import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["className", "id", "size", "src", "hasBorder", "name", "mode", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { useHasImageLoaded } from '../Image';
import { prefix } from '../../tools/settings';
import { StyledAvatar, StyledAvatarContainer, StyledAvatarChildren, StyledAvatarName, StyledAvatarImage } from './Avatar.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getInitials = function getInitials(name) {
  var _name$split = name.split(' '),
      _name$split2 = _slicedToArray(_name$split, 2),
      firstName = _name$split2[0],
      lastName = _name$split2[1];

  if (firstName && lastName) {
    return "".concat(firstName.charAt(0)).concat(lastName.charAt(0));
  } else {
    return firstName.charAt(0);
  }
};

var AvatarName = function AvatarName(_ref) {
  var name = _ref.name;
  return _jsx(StyledAvatarName, {
    "aria-label": name,
    children: name ? getInitials(name) : null
  });
};

var DefaultAvatar = function DefaultAvatar(props) {
  return _jsx("div", _objectSpread(_objectSpread({
    style: {
      width: '100%',
      height: '100%'
    }
  }, props), {}, {
    children: _jsx("svg", {
      fill: "#fff",
      viewBox: "0 0 128 128",
      role: "img",
      children: _jsxs("g", {
        children: [_jsx("path", {
          d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
        }), _jsx("path", {
          d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
        })]
      })
    })
  }));
};

var Avatar = forwardRef(function (_ref2, ref) {
  var _cx;

  var customClassName = _ref2.className,
      id = _ref2.id,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size,
      src = _ref2.src,
      _ref2$hasBorder = _ref2.hasBorder,
      hasBorder = _ref2$hasBorder === void 0 ? true : _ref2$hasBorder,
      name = _ref2.name,
      mode = _ref2.mode,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var hasLoaded = useHasImageLoaded({
    src: src
  });
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-avatar"), true), _defineProperty(_cx, "".concat(prefix, "-avatar--border"), hasBorder), _defineProperty(_cx, "".concat(prefix, "-avatar--has-image"), src && hasLoaded), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var renderChildren = function renderChildren() {
    if (src && hasLoaded) {
      return _jsx(StyledAvatarImage, {
        src: src,
        alt: name
      });
    }

    if (src && !hasLoaded) {
      if (name) {
        return _jsx(AvatarName, {
          name: name
        });
      } else {
        return _jsx(DefaultAvatar, {
          "aria-label": name
        });
      }
    }

    if (!src && name) {
      return _jsx(AvatarName, {
        name: name
      });
    }

    return _jsx(DefaultAvatar, {
      "aria-label": name
    });
  };

  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsxs(StyledAvatarContainer, {
      children: [_jsx(StyledAvatar, _objectSpread(_objectSpread({
        ref: ref,
        className: className
      }, rest), {}, {
        children: renderChildren()
      })), children && _jsx(StyledAvatarChildren, {
        children: children
      })]
    })
  });
});
Avatar.displayName = 'Avatar';
export default Avatar;